import React, { PropTypes, Component } from 'react';
import {
  List,
  Styles,
  Paper,
  ListItem,
  ListDivider,
  Avatar,
  DropDownMenu,
  RaisedButton
} from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';
import MediaQuery from 'services/MediaQuery';
import * as Colors from 'components/Material/Styles/Colors';
import SearchBarToolbar from 'components/SearchBarToolbar';
import Loader from 'components/Material/Loader';
import NotificationActions from 'actions/Notification';
import Message from 'services/Message';

let { Spacing } = Styles;

const css = oxygenCss({
  listWrapper: {
    padding: `0px 0px 76px 0px`
  }
});

const styles = {
  markRead: {
    margin: '10px',
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
};

export default class ListDetail extends Component {
  state = {
    // maxItems: this.props.initialItemCount,
    searchEnabled: false,
    media: MediaQuery.detect(),
    deleted: {},
    selected: {}
  };

  static propTypes = {
    hasDivider: PropTypes.bool,
    labelProperty: PropTypes.string,
    idProperty: PropTypes.string,
    emailProperty: PropTypes.string,
    items: PropTypes.array,
    onTouchTapItem: PropTypes.func,
    searchText: PropTypes.string,
    initialItemCount: PropTypes.number,
    filterChange: PropTypes.number,
    listItemGenerator: PropTypes.func,
    loading: PropTypes.bool,
    divider: PropTypes.bool
  };

  static defaultProps = {
    divider: true,
    searchText: null,
    labelProperty: 'name',
    idProperty: 'id',
    emailProperty: 'email',
    initialItemCount: 25,
    hasDivider: true,
    items: [],
    swipeEnabled: true,
    dangerouslySetInnerHTML: false
  };

  static contextTypes = {
    router: PropTypes.object,
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  /**
   * Returns the fitting style for the whole object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */
  getStyle() {
    let style = { position: 'relative', height: '100%' };
    // backgroundColor: this.context.muiTheme.rawTheme.palette.primary1Color
    return style;
  }

  /**
   * Returns the fitting style for the detail object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */
  getDetailStyle(hasDetail, hasFloatingActionButton) {
    let left = 8;
    let right = 8;
    if (this.context.media === 'desktop') {
      left = Spacing.desktopKeylineIncrement * 7;
      right =
        (hasFloatingActionButton && Spacing.desktopKeylineIncrement * 2) ||
        Spacing.desktopGutter;
    } else if (this.context.media === 'tablet') {
      left = Spacing.desktopKeylineIncrement * 6;
      right =
        (hasFloatingActionButton && Spacing.desktopKeylineIncrement * 2) ||
        Spacing.desktopGutter;
    }
    let backgroundColor =
      this.props.detailBackground || this.context.muiTheme.cardColor;
    return {
      position: 'absolute',
      left: left,
      right: right,
      top: 0,
      bottom: 0,
      backgroundColor: backgroundColor,
      overflow: 'auto',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    };
    // transform: 'translate3d(0,0,0)'
  }

  /**
   * Returns the fitting style for the toolbar object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */
  getToolbarStyle(hasDetail) {
    let style = {
      backgroundColor: this.context.muiTheme.primary1Color,
      borderStyle: 'none none solid none',
      borderWidth: '1px',
      borderColor: '#DDD'
    };
    if (hasDetail) {
      if (this.context.media === 'desktop') {
        style.width = Spacing.desktopKeylineIncrement * 7;
      } else if (this.context.media === 'tablet') {
        style.width = Spacing.desktopKeylineIncrement * 6;
      }
    }
    return style;
  }

  /**
   * Returns the fitting style for the list object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */
  getListStyle(hasDetail = false) {
    let style = {
      boxSizing: 'border-box',
      position: 'relative',
      height: '100%'
    };
    if (hasDetail) {
      if (this.context.media === 'desktop') {
        style.width = Spacing.desktopKeylineIncrement * 7;
      } else if (this.context.media === 'tablet') {
        style.width = Spacing.desktopKeylineIncrement * 6;
      }
    }
    return style;
  }

  getSearchHeaderStyle() {
    let style = {
      backgroundColor: this.context.muiTheme.rawTheme.palette.primary1Color
    };
    return style;
  }

  getSearchBarStyle(hasDetail = false, hasFloatingActionButton = false) {
    let style = { boxSizing: 'border-box' };
    if (hasDetail) {
      if (this.context.media === 'desktop') {
        style.width = Spacing.desktopKeylineIncrement * 7;
      } else if (this.context.media === 'tablet') {
        style.width = Spacing.desktopKeylineIncrement * 6;
      }
    } else if (hasFloatingActionButton && this.context.media !== 'phone') {
      style.marginRight = Spacing.desktopKeylineIncrement * 1.5;
      style.marginLeft = Spacing.desktopKeylineIncrement * 1.5;
    }

    return style;
  }

  /**
   * Callback function used when no custom filter is supplied for this ListDetail.
   * Will resort to just checking for the searchText
   *
   * @param {object}  item             Object to check
   * @param {string}  searchText       Piece of text that needs to be contained in the label to pass the filter
   * @param {string}  labelProperty    What property of the item is used as it's label
   *
   * @return {boolean}                 True if the label of the object contains searchText, false otherwise
   */
  // filter(item, searchText, labelProperty, emailProperty) {
  //   if (searchText && searchText !== '') {
  //     return (
  //       item[labelProperty].search(searchText) > -1 ||
  //       item[emailProperty].search(searchText) > -1
  //     );
  //   } else {
  //     return true;
  //   }
  // }

  filter(item, searchText, labelProperty) {
    if (searchText && searchText !== '') {
      return item[labelProperty].search(searchText) > -1;
    } else {
      return true;
    }
  }

  /**
   * Gets called whenever the user taps or clicks a list item
   *
   * @param  {object} item Item that was represented in the 'touched' list item
   * @param  {[type]} e    Javascript event
   */
  onTouchTapItem(item, e) {
    if (this.props.onTouchTapItem) {
      this.props.onTouchTapItem(item, e);
    }
    this.setState({ selected: item });
  }

  /**
   * Gets called by the scroll container whenever the list was scrolled all the way to the bottom.
   * This is used to dynamically popuplate the list with more items upon reaching the bottom
   */
  // onScrollToBottom() {
  //   this.setState({
  //     maxItems: this.state.maxItems + 10
  //   });
  // }

  /**
   * [dropDownChange description]
   * @param  {[type]} e             [description]
   * @param  {[type]} selectedIndex [description]
   * @param  {[type]} menuItem      [description]
   * @return {[type]}               [description]
   */
  dropDownChange(e, selectedIndex, menuItem) {
    if (this.props.onFilterChange) {
      this.props.onFilterChange(menuItem);
    }
  }

  /**
   * Gets called upon user enabling the search bar
   */
  enableSearch() {
    this.setState({ searchEnabled: true });
  }

  /**
   * Gets called upon user disab ling the search bar
   */
  disableSearch() {
    this.setState({ searchEnabled: false });
  }

  getFloatingActionButtonStyle() {
    let style,
      componentTheme = this.context.muiTheme;
    if (this.context.media === 'phone') {
      style = {
        position: 'fixed',
        right: Spacing.desktopGutter,
        bottom: Spacing.desktopGutter,
        zIndex: 3
      };
    } else {
      style = {
        position: 'fixed',
        right: Spacing.desktopKeylineIncrement / 2,
        top:
          componentTheme.toolbar.height * 2 -
          componentTheme.floatingActionButton.buttonSize / 2,
        zIndex: 3
      };
      if (this.state.searchEnabled) {
        style.top = style.top + componentTheme.floatingActionButton.buttonSize;
      }
    }
    return style;
  }

  onSearchTextChange = (searchText) => {
    if (searchText !== this.state.searchText) {
      this.setState({ searchText });
    }
  }

  getItemStyle() {
    let style = {};
    return style;
  }

  markAllRead() {
    const { items } = this.props;
    items.forEach(item => {
      NotificationActions.markRead([item.id], 1);
    });

    Message.info(this.context.getIntlMessage('notification.removed'));
  }

  render() {
    const { loading, filterBar, containerStyle, pagination } = this.props;
    let children = [],
      list,
      detail,
      currentLetter,
      lastLetter,
      filterDropDown,
      markReadAllButton,
      floatingActionButton,
      hasDivider = this.props.hasDivider,
      searchText = this.state.searchText,
      regexp = '',
      items = this.props.items || [];

    const filter = this.props.filter || this.filter,
      labelProperty = this.props.labelProperty,
      idProperty = this.props.idProperty,
      emailProperty = this.props.emailProperty;

    if (searchText && searchText !== '') {
      try {
        regexp = new RegExp(searchText, 'i');
      } catch (e) {
        regexp = new RegExp();
      }
    }
    items = items
      .filter(item => {
        return filter(item, regexp, labelProperty, emailProperty);
      });
      // .splice(0, this.state.maxItems);

    for (let i = 0; i < items.length; i++) {
      let item = items[i],
        currentLetter,
        label,
        id = item[idProperty],
        leftAvatar;
      if (this.state.deleted[id]) {
        continue;
      }
      if (hasDivider) {
        currentLetter =
          (item[labelProperty] && item[labelProperty][0].toUpperCase()) || '';
        if (lastLetter !== currentLetter) {
          leftAvatar = <Avatar>{currentLetter}</Avatar>;
          lastLetter = currentLetter;
        }
      }
      if (this.props.formatLabel) {
        label = this.props.formatLabel(item);
      } else {
        label = item[labelProperty];
      }
      if (this.props.listItemGenerator) {
        children.push(
          this.props.listItemGenerator(item, leftAvatar, hasDivider)
        );
      } else if (this.props.dangerouslySetInnerHTML) {
        let primaryText = <div dangerouslySetInnerHTML={{ __html: label }} />;
        children.push(
          <ListItem
            leftAvatar={leftAvatar}
            insetChildren={hasDivider}
            key={'i-' + id}
            onTouchTap={this.onTouchTapItem.bind(this, item)}
            primaryText={primaryText}
          />
        );
      } else {
        let style = this.getItemStyle();
        if (
          this.state.selected &&
          item[idProperty] === this.state.selected[idProperty]
        ) {
          style.backgroundColor = Colors.Colors.grey[300].material;
          //style.color = this.context.muiTheme.rawTheme.palette.primary3TextColor;
        }
        children.push(
          <ListItem
            style={style}
            leftAvatar={leftAvatar}
            insetChildren={hasDivider}
            key={'i-' + id}
            onTouchTap={this.onTouchTapItem.bind(this, item)}
            primaryText={label}
          />
        );
      }
      if (this.props.divider) {
        children.push(<ListDivider inset={hasDivider} key={'d-' + id} />);
      }
    }

    let hasDetail = this.props.children;

    floatingActionButton =
      this.props.floatingActionButton &&
      React.cloneElement(this.props.floatingActionButton, {
        style: this.getFloatingActionButtonStyle(hasDetail)
      });

    if (hasDetail) {
      detail = (
        <Paper
          style={this.getDetailStyle(hasDetail, floatingActionButton)}
          zDepth={1}
        >
          {this.props.children}
        </Paper>
      );
    }
    if (this.props.filterOptions) {
      filterDropDown = (
        <DropDownMenu
          onChange={this.dropDownChange.bind(this)}
          menuItems={this.props.filterOptions}
        />
      );
    }

    if (
      this.props.types &&
      this.props.types[-1] &&
      this.props.filtering.payload == 'all' &&
      this.props.items.length != 0
    ) {
      markReadAllButton = (
        <RaisedButton
          label={this.context.getIntlMessage('notification.readAll')}
          onTouchTap={this.markAllRead.bind(this)}
        />
      );
    } else {
      markReadAllButton = null;
    }

    list = (
      <div className={css.listWrapper}>
        <List>
          {this.props.listHeader}
          {loading && <Loader />}
          {children}
        </List>
      </div>
    );

    return (
      <div style={this.getStyle(hasDetail)}>
        <div style={this.getSearchHeaderStyle()}>
          <div
            style={this.getSearchBarStyle(hasDetail, !!floatingActionButton)}
          >
            <SearchBarToolbar
              fullWidth={true}
              onChange={this.onSearchTextChange}
            />
          </div>
        </div>
        <div style={styles.markRead}>
          {filterDropDown}
          {pagination}
          {markReadAllButton}
        </div>

        {!loading && filterBar}
        <div style={this.getListStyle(hasDetail)}>
          <ScrollableContainer
            containerStyle={{
              ...containerStyle,
              backgroundColor: this.context.muiTheme.canvasColor
            }}
            // onScrollToBottom={this.onScrollToBottom.bind(this)}
          >
            {list}
          </ScrollableContainer>
        </div>
        {floatingActionButton}
        {detail}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/ListDetail.js